import angular from 'angular';
import {
  alerts,
  ssAutocomplete
} from 'app/components/global';
import directive from './em-succession-planning.directive';
import controller from './em-succession-planning.controller';

// Validation
import processSuccessionMessagesTpl from './messages/processSuccession.messages.html';

export default angular.module('app.components.advisory.enterpriseModeling.emSuccessionPlanning', [
  alerts,
  ssAutocomplete
])
  .directive('emSuccessionPlanning', directive)
  .controller('EMSuccessionPlanningController', controller)
  .run(($templateCache) => {
    $templateCache.put(
      'processSuccession.messages.html', processSuccessionMessagesTpl
    );
  })
  .name;

console.log('app.components.advisory.enterpriseModeling.emSuccessionPlanning created');
